import { extends as _extends } from '../../_virtual/_rollupPluginBabelHelpers.js';
import React from 'react';
import { pickDataAttributes } from '../../utils/pickDataAttributes.js';
import { formatClassName as _formatClassName } from '../../utils/formatClassName.js';

var ProgressSpinner = function ProgressSpinner(props) {
  var classNames = props.classNames,
      _props$color = props.color,
      color = _props$color === void 0 ? 'primary' : _props$color,
      containerClassName = props.containerClassName,
      pageLoader = props.pageLoader,
      _props$size = props.size,
      size = _props$size === void 0 ? 'xl' : _props$size;
  var dataAttributes = pickDataAttributes(props, 'progress-spinner');
  var styles = classNames || "preloader pl-".concat(size, " pls-").concat(color);
  var containerStyles = containerClassName || (pageLoader ? 'page-loader' : 'preloader-container');

  if (typeof document !== 'undefined' && !pageLoader) {
    var body = document.querySelector('body');

    if (body !== null && body !== void 0 && body.className.includes('loading')) {
      body.className = body.className.replace('loading', '');
    }
  }

  return /*#__PURE__*/React.createElement("div", {
    className: _formatClassName([containerStyles, 'd-print-none'])
  }, /*#__PURE__*/React.createElement("div", _extends({
    className: styles
  }, dataAttributes), /*#__PURE__*/React.createElement("svg", {
    className: "pl-circular",
    viewBox: "25 25 50 50"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "plc-path",
    cx: "50",
    cy: "50",
    r: "20"
  }))));
};

ProgressSpinner.displayName = "ProgressSpinner";
ProgressSpinner.displayName = 'ProgressSpinner';
export { ProgressSpinner };